import React from 'react';
import {connect} from 'react-redux';
import {SessionAwareComponent} from './SessionAwareComponent';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import Page from '../../../frontend/app/components/Page';
import styles from '../../../frontend/account/containers/css/Login.scss';
import Alert from '../../../ui/Alert';
import {FormattedMessage} from 'react-intl';
import LoginForm from '../../../frontend/account/forms/Login';
import {createSubmitAction} from '../../../frontend/app/forms';
import {LOGIN_FAILURE, LOGIN_SUBMIT, LOGIN_SUCCESS} from '../../../frontend/app/session';

export class SessionRequired extends SessionAwareComponent {
    static propTypes = {
        children: PropTypes.node,
        session: ImmutablePropTypes.map.isRequired,
    }

    constructor(props) {
        super(props);
        this.state = { showLoginComponent: false };
    }

    componentDidMount() {
        this.onSessionChange(null, this.props.session);
    }

    onSessionChange(prevSession, session) {
        this.setState({ showLoginComponent: !session || !session.get('authenticated') });
    }

    render() {
        const { showLoginComponent, erroneous } = this.state;
        const { children } = this.props;

        if (!showLoginComponent) {
            return (<div>{children}</div>);
        }

        return (
            <Page.Body>
                <div className={styles.wrapper}>
                    {erroneous && (
                        <Alert type='danger'>
                            <FormattedMessage id='frontend.form_login.message.invalid' />
                        </Alert>
                    )}
                    <LoginForm.Component
                        onSubmitFail={() => this.setState({ erroneous: true })}
                        onSubmitSuccess={() => {}}
                        onSubmit={createSubmitAction(
                            LOGIN_SUBMIT,
                            LOGIN_SUCCESS,
                            LOGIN_FAILURE,
                        )}
                    />
                </div>
            </Page.Body>
        );
    }
}

export default connect(() => ({}))(SessionRequired);
